module.exports = __webpack_public_path__ + "static/media/img-gift.16935499.png";